
/* HUMBOFIL 3D - CARRITO DE COTIZACIONES V1 */
(() => {
  'use strict';

  if (window.HumboFilCart) return;

  const KEY = 'humbofil_quote_cart_v1';
  const MAX_QTY = 999;
  let items = [];
  let panel;
  let overlay;
  let list;
  let total;
  let count;
  let previousFocus = null;

  const money = cents =>
    new Intl.NumberFormat('es-PE', {
      style: 'currency',
      currency: 'PEN'
    }).format(cents / 100);

  const escapeHTML = value =>
    String(value ?? '').replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;',
      '"': '&quot;', "'": '&#39;'
    }[c]));

  const quantity = value => {
    const n = Number(value);
    return Number.isInteger(n) && n >= 1 && n <= MAX_QTY
      ? n : null;
  };

  function load() {
    try {
      const stored = JSON.parse(localStorage.getItem(KEY) || '[]');
      items = Array.isArray(stored)
        ? stored.filter(x =>
            x && x.id && quantity(x.qty) !== null &&
            Number.isInteger(x.price) && x.price >= 0
          ).slice(0, 100)
        : [];
    } catch {
      items = [];
    }
  }

  function save() {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch {
      alert('No se pudo guardar el pedido en este navegador.');
    }
    render();
  }

  function totals() {
    return {
      units: items.reduce((n, x) => n + x.qty, 0),
      amount: items.reduce((n, x) => n + x.price * x.qty, 0)
    };
  }

  function open() {
    previousFocus = document.activeElement;
    render();
    overlay.hidden = false;
    panel.hidden = false;
    document.body.classList.add('hf-cart-open');
    panel.querySelector('[data-hfc-close]').focus();
  }

  function close() {
    panel.hidden = true;
    overlay.hidden = true;
    document.body.classList.remove('hf-cart-open');
    previousFocus?.focus?.();
  }

  function addFromForm(form) {
    const select = form.querySelector('select[name="variant"]');
    const option = select?.selectedOptions?.[0];
    const qty = quantity(
      form.querySelector('input[name="quantity"]')?.value
    );
    const id = option?.dataset.variantId;
    const price = Number(option?.dataset.priceCents);

    if (!id || !qty || !Number.isInteger(price) || price < 0) {
      alert('Selecciona una presentación y una cantidad válida.');
      return;
    }

    const card = form.closest('.hf-product');
    const image = card?.querySelector('.hf-product-img');
    const existing = items.find(x => x.id === id);

    if (existing) {
      if (existing.qty + qty > MAX_QTY) {
        alert('El máximo es 999 unidades por presentación.');
        return;
      }
      existing.qty += qty;
      existing.price = price;
    } else {
      items.push({
        id,
        title: form.dataset.title || 'Producto',
        variant: option.value || 'Presentación única',
        qty,
        price,
        url: form.dataset.url || '',
        image: option.dataset.image ||
          image?.getAttribute('src') || ''
      });
    }

    save();
    open();
  }

  /* HUMBOFIL - PRODUCTOS INDIVIDUALES */

function addFromProductPage(form) {
  const component = form.closest('product-form-component');

  const variantId = String(
    form.querySelector('[name="id"]')?.value || ''
  );

  const variantsScript = component?.querySelector(
    '[data-hfc-product-variants]'
  );

  let variants = [];

  try {
    variants = JSON.parse(variantsScript?.textContent || '[]');
  } catch (error) {
    console.error('HumboFil: error leyendo variantes', error);
  }

  const variant = variants.find(
    item => String(item.id) === variantId
  );

  if (!variant) {
    alert('No se pudo identificar la variante seleccionada.');
    return;
  }

  const details = form.closest('.product-details');

  const qtyInput =
    form.querySelector('[name="quantity"]') ||
    details?.querySelector('input[name="quantity"]') ||
    component?.querySelector('input[name="quantity"]');

  const qty = quantity(qtyInput?.value || 1);

  if (!qty) {
    alert('Ingresa una cantidad válida entre 1 y 999.');
    return;
  }

  const price = Number(variant.price);

  if (!Number.isInteger(price) || price < 0) {
    alert('No se pudo obtener el precio del producto.');
    return;
  }

  const id = String(variant.id);
  const existing = items.find(item => String(item.id) === id);

  if (existing && existing.qty + qty > MAX_QTY) {
    alert('El máximo es 999 unidades por presentación.');
    return;
  }

  const title = form.dataset.hfcTitle || 'Producto';

  const variantTitle =
    variant.title && variant.title !== 'Default Title'
      ? variant.title
      : 'Presentación única';

  const productUrl = form.dataset.hfcUrl || '';

  const url = productUrl
    ? new URL(productUrl, window.location.origin).href
    : window.location.href;

  const image =
  variant.featured_image?.src ||
  variant.featured_image?.url ||
  form.dataset.hfcImage ||
  '';

  if (existing) {
    existing.qty += qty;
    existing.price = price;
    existing.title = title;
    existing.variant = variantTitle;
    existing.url = url;
    existing.image = image;
  } else {
    items.push({
      id,
      title,
      variant: variantTitle,
      qty,
      price,
      url,
      image
    });
  }

  save();
  open();
}

document.addEventListener('submit', event => {
  const form = event.target.closest(
    'form[data-hfc-product-form]'
  );

  if (!form) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  addFromProductPage(form);
}, true);

/* INTERCEPTAR SOLO EL BOTÓN AGREGAR AL CARRITO */

document.addEventListener('click', event => {
  const button = event.target.closest(
    'form[data-hfc-product-form] button[name="add"], ' +
    'form[data-hfc-product-form] button[type="submit"][name="add"]'
  );

  if (!button) return;

  const form = button.closest('form[data-hfc-product-form]');

  if (!form || button.disabled) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  addFromProductPage(form);
}, true);

  function render() {
    if (!list) return;

    const summary = totals();
    total.textContent = money(summary.amount);
    count.textContent = summary.units;

    document.querySelectorAll('[data-hfc-count]').forEach(el => {
      el.textContent = summary.units > 99 ? '99+' : summary.units;
      el.hidden = summary.units === 0;
    });

    if (!items.length) {
      list.innerHTML =
        '<p class="hfc-empty">Tu pedido está vacío. Explora nuestro catálogo y agrega tus favoritos.</p>';
      return;
    }

    list.innerHTML = items.map((item, index) => `
      <article class="hfc-item">
        ${item.image
          ? `<img class="hfc-item-image"
                  src="${escapeHTML(item.image)}"
                  alt="" loading="lazy">`
          : '<div class="hfc-item-image"></div>'}
        <div class="hfc-item-info">
          <strong>${escapeHTML(item.title)}</strong>
          <small>${escapeHTML(item.variant)}</small>
          <span>${money(item.price)} c/u</span>
          <div class="hfc-item-controls">
            <button type="button" data-hfc-minus="${index}"
                    aria-label="Reducir cantidad">−</button>
            <span>${item.qty}</span>
            <button type="button" data-hfc-plus="${index}"
                    aria-label="Aumentar cantidad">+</button>
            <button type="button" class="hfc-remove"
                    data-hfc-remove="${index}">Eliminar</button>
          </div>
          <b>${money(item.price * item.qty)}</b>
        </div>
      </article>
    `).join('');
  }

  function sendWhatsApp() {
    if (!items.length) {
      alert('Agrega productos antes de enviar tu pedido.');
      return;
    }

    const phone = (
      document.querySelector('[data-hfc-panel]')?.dataset.phone || ''
    ).replace(/\D/g, '');

    if (!/^51\d{9}$/.test(phone)) {
      alert('Configura el número de WhatsApp de HumboFil.');
      return;
    }

    const lines = [
      'Hola HumboFil 3D 👋',
      'Quisiera cotizar el siguiente pedido:',
      ''
    ];

    items.forEach((x, i) => {
      lines.push(`${i + 1}. ${x.title}`);
      lines.push(`Presentación: ${x.variant}`);
      lines.push(`Cantidad: ${x.qty}`);
      lines.push(`Precio referencial: ${money(x.price)}`);
      lines.push(`Subtotal: ${money(x.price * x.qty)}`);
      if (x.url) lines.push(`Producto: ${x.url}`);
      lines.push('');
    });

    lines.push(`TOTAL ESTIMADO: ${money(totals().amount)}`);
    lines.push('');
    lines.push('¿Podrían confirmarme disponibilidad y entrega?');

    const url = `https://wa.me/${phone}?text=${
      encodeURIComponent(lines.join('\n'))
    }`;

    const opened = window.open(url, '_blank', 'noopener,noreferrer');
    if (!opened) window.location.href = url;
  }

  function createPanel() {
    overlay = document.createElement('div');
    overlay.className = 'hfc-overlay';
    overlay.hidden = true;

    panel = document.createElement('aside');
    panel.className = 'hfc-panel';
    panel.hidden = true;
    panel.dataset.hfcPanel = '';
    panel.dataset.phone = window.HUMBOFIL_PHONE || '';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Mi pedido HumboFil');

    panel.innerHTML = `
      <div class="hfc-header">
        <div>
          <strong>Mi pedido</strong>
          <small>Carrito de cotizaciones HumboFil 3D</small>
        </div>
        <button type="button" data-hfc-close
                aria-label="Cerrar carrito">✕</button>
      </div>
      <div class="hfc-list" data-hfc-list></div>
      <div class="hfc-footer">
        <div class="hfc-total">
          <span>Subtotal estimado</span>
          <strong data-hfc-total>S/ 0.00</strong>
        </div>
        <small>Precios referenciales. El pago y la entrega se coordinan por WhatsApp.</small>
        <button type="button" class="hfc-send" data-hfc-send>
          Enviar pedido por WhatsApp ↗
        </button>
        <button type="button" class="hfc-continue" data-hfc-close>
          Seguir explorando
        </button>
      </div>
    `;

    document.body.append(overlay, panel);
    list = panel.querySelector('[data-hfc-list]');
    total = panel.querySelector('[data-hfc-total]');
    count = document.createElement('span');

    overlay.addEventListener('click', close);
  }

  document.addEventListener('click', event => {
    const add = event.target.closest('[data-hfc-add]');
    if (add) {
      event.preventDefault();
      const form = add.closest('form[data-hf-quote]');
      if (form) addFromForm(form);
      return;
    }

    if (event.target.closest('[data-hfc-open]')) {
      event.preventDefault();
      open();
      return;
    }

    if (event.target.closest('[data-hfc-close]')) {
      close();
      return;
    }

    if (event.target.closest('[data-hfc-send]')) {
      sendWhatsApp();
      return;
    }

    const control = event.target.closest(
      '[data-hfc-plus], [data-hfc-minus], [data-hfc-remove]'
    );
    if (!control) return;

    const index = Number(
      control.dataset.hfcPlus ??
      control.dataset.hfcMinus ??
      control.dataset.hfcRemove
    );

    if (!Number.isInteger(index) || !items[index]) return;

    if (control.hasAttribute('data-hfc-remove')) {
      items.splice(index, 1);
    } else if (control.hasAttribute('data-hfc-plus')) {
      if (items[index].qty >= MAX_QTY) return;
      items[index].qty++;
    } else {
      items[index].qty--;
      if (items[index].qty < 1) items.splice(index, 1);
    }

    save();
  });

  document.addEventListener('keydown', event => {
    if (panel?.hidden) return;

    if (event.key === 'Escape') {
      close();
    }

    if (event.key === 'Tab') {
      const focusable = [...panel.querySelectorAll(
        'button:not([disabled]), a[href], input:not([disabled])'
      )].filter(el => el.getClientRects().length);

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey &&
                 document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  function init() {
    load();
    createPanel();
    render();
  }

  window.HumboFilCart = { open, close, addFromForm };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
